import { sanitizeString } from '@app/shared/helpers/sanitizeString';

export function searchBrand<T>(value: string, brands: Array<T & { title?: string; name?: string }>): T[] {
  return brands.filter(brand => sanitizeString(brand.name || brand.title).includes(sanitizeString(value)));
}
